import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import actionTypes from 'constants/actionTypes';
import { useAddHoldingClassModal } from '../context/AddHoldingClassModalContext';

const HoldingClassRights: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useAddHoldingClassModal();

  const isReadOnlyView = data.modalActionType === actionTypes.VIEW;

  return (
    <>
      <label className="form-label" htmlFor="pay-amount">
        {t('ClassRights')}
      </label>
      <div className="card card-preview mb-4">
        <div className="card-inner">
          <div className="row gy-3">
            <div className="col-md-4 col-sm-6">
              <div className="preview-block">
                <span className="preview-title overline-title">
                  {t('Ordinary')}
                </span>
                <div className="custom-control custom-checkbox checked">
                  <input
                    type="checkbox"
                    id="rights-conversion"
                    className="custom-control-input"
                    checked={data.hasConversionRights}
                    onChange={actions.handleChangeHasConversionRights}
                    disabled={isReadOnlyView}
                  />
                  <label
                    className="custom-control-label"
                    htmlFor="rights-conversion"
                  >
                    {t('RightOfConversionToPOrdin')}
                  </label>
                </div>
              </div>
            </div>

            <div className="col-md-4 col-sm-6">
              <div className="preview-block">
                <span className="preview-title overline-title">
                  {t('Settlement')}
                </span>
                <div className="custom-control custom-checkbox checked">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="rights-liquidation"
                    checked={data.hasLiquidationRights}
                    onChange={actions.handleChangeHasLiquidationRights}
                    disabled={isReadOnlyView}
                  />
                  <label
                    className="custom-control-label"
                    htmlFor="rights-liquidation"
                  >
                    {t('PreferentialLiquidationLa')}
                  </label>
                </div>
              </div>
            </div>

            <div className="col-md-4 col-sm-6">
              <div className="preview-block">
                <span className="preview-title overline-title">
                  {t('Antidilution')}:
                </span>
                <div className="custom-control custom-checkbox checked">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="rights-antidilution"
                    checked={data.hasAntidilutionRights}
                    onChange={actions.handleChangeHasAntidilutionRights}
                    disabled={isReadOnlyView}
                  />
                  <label
                    className="custom-control-label"
                    htmlFor="rights-antidilution"
                  >
                    {t('Anti-DilutionLaw')}
                  </label>
                </div>
              </div>
            </div>

            <div className="col-12">
              <p className="text-soft">{t('IfYouMarkAnyOfTheBoxesYou')}</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HoldingClassRights;
